import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './NotFound.css';

const NotFound = () => {
  const { t } = useTranslation('public');

  return (
    <div className="not-found-page">
      <div className="container main-content">
        <div className="not-found-card">
          <span className="material-symbols-outlined not-found-icon" aria-hidden="true">
            search_off
          </span>
          <h1 className="not-found-title">{t('notFoundTitle')}</h1>
          <p className="not-found-message">{t('notFoundMessage')}</p>
          <div className="not-found-actions">
            <Link to="/dashboard" className="btn btn-primary">
              {t('goToDashboard')}
            </Link>
            <Link to="/tasks" className="btn btn-secondary">
              {t('viewTasks')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
